import * as lodash from 'lodash';

export function clone<T>(value: T): T {
  return lodash.cloneDeep(value);
}